import React from 'react';
import searchStyles from '../../styles/search.scss';
import FilterContent from './FilterContent';

interface FilterCategory {
  key: string;
  category: string;
  label: string;
}

interface FundTableFilterProps {
  isFilterOpen: boolean;
  handleFilterToggle: () => void;
  clearAllFilters: () => void;
  filtersToApply: Record<string, any>;
  filterCategoryValueMap: Record<string, any>;
  filterCategoryMap: FilterCategory[];
  filterDataMap: Record<string, any>;
  onChangeFilter: (e: React.MouseEvent<HTMLImageElement>) => void;
  selectedTabFilter?: string;
  isMobile: boolean;
}

const FundTableFilter: React.FC<FundTableFilterProps> = ({
  isFilterOpen,
  handleFilterToggle,
  clearAllFilters,
  filtersToApply,
  filterCategoryValueMap,
  filterCategoryMap,
  filterDataMap,
  onChangeFilter,
  selectedTabFilter,
  isMobile,
}) => {
  return (
    <div className="lil-relative">
      <button
        className="lil-bg-white lil-border-separate lil-border-grey-300 lil-rounded-xxl lil-border-spacing-0 lil-border-sm lil-mr-4 sm:lil-mr-0 lil-px-4 lil-py-1 sm:lil-px-3 sm:lil-py-1 lil-whitespace-nowrap lil-min-w-[100px] sm:lil-min-w-[80px]"
        onClick={handleFilterToggle}
      >
        <div className="lil-flex lil-items-center lil-justify-center lil-gap-2">
          <img
            className="lil-w-4 lil-h-4"
            src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742454620_filter.svg"
            alt="Filter"
          />
          <span className="lil-text-s-14 lil-inline-block">Filter</span>
        </div>
      </button>
      {isFilterOpen && (
        <div>
          <div
            className="lil-fixed lil-inset-0 lil-bg-transparent sm:lil-bg-opacity-0 sm:lil-bg-grey-900 sm:lil-bg-opacity-75 sm:lil-transition-opacity"
            style={{ zIndex: 1 }}
            onClick={handleFilterToggle}
          ></div>
          <div
            className="lil-absolute lil-mt-2 lil-bg-white lil-shadow-lg lil-rounded-lg lil-border-separate lil-border-grey-300 lil-border-spacing-0 lil-border-sm lil-right-0 lil-left-auto"
            style={{
              position: isMobile ? 'fixed' : 'absolute',
              width: isMobile ? '350px' : '400px',
              maxHeight: '80vh',
              overflowY: 'auto',
              zIndex: isMobile ? 11 : 2,
              ...(isMobile
                ? {
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    right: 'auto',
                  }
                : {
                    top: '100%',
                    right: '10px',
                    left: 'auto',
                    transform: 'none',
                  }),
            }}
          >
            <div className="lil-px-4 lil-pt-6">
              <span className="lil-font-bold">Filter By:</span>
              <div
                style={{ float: 'right' }}
                className="lil-flex lil-items-center lil-gap-2"
              >
                <span
                  className={`lil-text-blue-350 lil-text-s-14 lil-font-medium lil-cursor-pointer ${searchStyles['clear-all-filters']} sm:lil-mr-4`}
                  onClick={clearAllFilters}
                >
                  Reset All
                </span>
                {isMobile && (
                  <img
                    src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1743508860_largeclosebutton.svg"
                    alt="Close"
                    className="lil-w-5 lil-h-5 lil-cursor-pointer"
                    onClick={handleFilterToggle}
                  />
                )}
              </div>
            </div>
            <FilterContent
              selectedTabFilter={selectedTabFilter}
              filtersToApply={filtersToApply}
              filterCategoryValueMap={filterCategoryValueMap}
              filterCategoryMap={filterCategoryMap}
              filterDataMap={filterDataMap}
              onChangeFilter={onChangeFilter}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FundTableFilter;



// WEBPACK FOOTER //
// ./components/amcNew/FundTableFilter.tsx